export const COINGECKO = "https://api.coingecko.com/api/v3";
export const PREVIEW_ERRORS = "https://api.errors.preview.sundaeswap.finance/dex-v2/new-report";
export const ERRORS_API_URL =
  process.env.NODE_ENV === "development" ? PREVIEW_ERRORS : window.__APP_CONFIG.apiUrls.errors;
